import MileageDictionaryListRequest, {
  MileageDictionaryListRequestQueryParams,
} from "./mileage-dictionary-list.request";

const createQueryParams = (
  request: MileageDictionaryListRequest,
): MileageDictionaryListRequestQueryParams => {
  return {
    active: request.active,
    limit: request.limit,
    offset: request.offset,
  };
};

const mileageDictionaryListRequestFactory = {
  createQueryParams,
};

export default mileageDictionaryListRequestFactory;
